import { ApprovalOperation, ApprovalRules, ApprovalStatus } from 'ui-product-approvals-common';
import { ACTOR } from '../constants/actors';
import { APPROVAL_RULES_ALL_APPROVERS, APPROVAL_RULES_ANY_APPROVER } from '../constants/trackingConstants';
export const isNoteOperation = operation => operation === ApprovalOperation.APPROVE || operation === ApprovalOperation.REJECT || operation === ApprovalOperation.REQUEST_CHANGES;
export const submitNoteOperation = ({
  api,
  operation,
  stepId,
  note
}) => {
  switch (operation) {
    case ApprovalOperation.APPROVE:
      return stepId != null ? api.approveStep(stepId, note) : api.approve(note);
    case ApprovalOperation.REJECT:
      return stepId != null ? api.rejectStep(stepId, note) : api.reject(note);
    case ApprovalOperation.REQUEST_CHANGES:
      return stepId != null ? api.requestChangesStep(stepId, note) : api.requestChanges(note);
    default:
      return operation;
  }
};
export const getNoteOperationTrackingExtra = (approval, operation, data) => {
  var _approval$data, _approval$data2;
  const {
    currentStepId,
    currentUser
  } = approval.meta;
  const approverStep = (_approval$data = approval.data) === null || _approval$data === void 0 || (_approval$data = _approval$data.approvalSteps) === null || _approval$data === void 0 ? void 0 : _approval$data.find(step => currentStepId != null ? step.id === currentStepId : step.approver.actor.actorType === ACTOR.USER && step.approver.actor.id === String(currentUser === null || currentUser === void 0 ? void 0 : currentUser.user_id));
  const extra = {
    userType: approverStep === null || approverStep === void 0 ? void 0 : approverStep.approver.actor.actorType
  };
  if (operation === ApprovalOperation.APPROVE && data && 'approvalStatus' in data && data.approvalStatus === ApprovalStatus.APPROVED) {
    extra.complete = true;
  }
  const approvalRules = (_approval$data2 = approval.data) === null || _approval$data2 === void 0 ? void 0 : _approval$data2.approvalRules;
  if (approvalRules === ApprovalRules.ANY_CAN_APPROVE) {
    extra.rules = APPROVAL_RULES_ANY_APPROVER;
  } else if (approvalRules === ApprovalRules.NON_SEQUENTIAL) {
    extra.rules = APPROVAL_RULES_ALL_APPROVERS;
  }
  return extra;
};